import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorage } from '@app/types/session-storage.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const DEFAULT_LANG = 'en';
    this.translate.setDefaultLang(DEFAULT_LANG);
    this.route.queryParams.subscribe((params) => {
      const COUNTRY = params.country;
      sessionStorage.setItem(SessionStorage.Country, COUNTRY);

      const LANG = params.lang || DEFAULT_LANG;
      sessionStorage.setItem(SessionStorage.Language, LANG);
      this.translate.use(LANG);

      const parentUrl = params.parentUrl || location.href;
      sessionStorage.setItem(SessionStorage.ParentUrl, parentUrl);

      const STUDENT_PHONE_NUMBER = params.studentPhoneNumber;
      sessionStorage.setItem(SessionStorage.StudentPhoneNumber, STUDENT_PHONE_NUMBER);

      const SERVICE_PHONE_NUMBER = params.servicePhoneNumber;
      sessionStorage.setItem(SessionStorage.ServicePhoneNumber, SERVICE_PHONE_NUMBER);
    });
  }
}
